import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/heider/Footer";
import VideoLightbox from "../components/heider/VideoLightbox";
import useReveal from "../hooks/useReveal";
import { Play, ArrowRight } from "lucide-react";

const FILMS = [
  { src: "/broker-open-2.mp4", title: "Broker Open Film", sub: "Sold $2.5M \u00b7 2.5\u20135 days on market" },
  { src: "/broker-french.mp4", title: "French Street", sub: "Sold $1.7M \u00b7 1 day on market" },
  { src: "/broker-mclean.mp4", title: "McLean Broker Open", sub: "Listing launch film" },
  { src: "/hero.mp4", title: "Estate Cinematics", sub: "Signature listing film" },
  { src: "/home2.mp4", title: "Home Tour", sub: "Cinematic walkthrough" },
  { src: "/reel3.mp4", title: "Behind the Listing", sub: "Brand film" },
];

const REELS = ["/broker-5940.mp4", "/frenchway.mp4", "/reelA.mp4", "/reelB.mp4", "/reelC.mp4"];

const Tile = ({ src, className, onOpen, testid, children }) => {
  const ref = useRef(null);
  useEffect(() => {
    const v = ref.current;
    const obs = new IntersectionObserver(([e]) => (e.isIntersecting ? v.play().catch(() => {}) : v.pause()), { threshold: 0.25 });
    obs.observe(v);
    return () => obs.disconnect();
  }, []);
  return (
  <button data-testid={testid} onClick={() => onOpen(src)} className={`group relative overflow-hidden bg-black w-full reveal-scale ${className}`}>
    <video ref={ref} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" loop muted playsInline preload="metadata">
      <source src={src} type="video/mp4" />
    </video>
    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent flex items-center justify-center">
      <span className="w-14 h-14 rounded-full bg-[#b4936a]/85 text-white flex items-center justify-center group-hover:scale-110 transition-transform"><Play size={20} className="ml-0.5" /></span>
    </div>
    {children}
  </button>
  );
};

const MediaPage = () => {
  const [active, setActive] = useState(null);
  useReveal();
  return (
    <div className="page-in">
      <section className="bg-[#0d0d0d] text-white pt-40 pb-20 md:pt-48 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">Media</p>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light" data-testid="media-title">Films, Reels &amp; Content</h1>
          <p className="text-white/55 text-[15px] leading-relaxed max-w-2xl mt-6">Every listing gets the production it deserves. Here is a look at the films and content that put our homes in front of 300K+ followers.</p>
        </div>
      </section>

      <section className="bg-[#0d0d0d] text-white pb-24 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-8">Listing Films</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {FILMS.map((f, i) => (
              <Tile key={f.src} src={f.src} onOpen={setActive} testid={`media-film-${i}`} className="aspect-video text-left">
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="font-serif-display text-xl">{f.title}</p>
                  <p className="text-[10px] tracking-luxe uppercase text-[#e7c9a3] mt-1">{f.sub}</p>
                </div>
              </Tile>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 reveal">
            <div>
              <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-3">From the Feed</p>
              <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a]">Social Reels</h2>
            </div>
            <Link to="/broker-opens" data-testid="media-broker-opens-link" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 hover:text-[#b4936a] hover:border-[#b4936a] transition-colors">See Our Broker Opens <ArrowRight size={14} /></Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
            {REELS.map((r, i) => <Tile key={r} src={r} onOpen={setActive} testid={`media-reel-${i}`} className="aspect-[9/16] rounded-[1.4rem]" />)}
          </div>
        </div>
      </section>

      <VideoLightbox src={active} onClose={() => setActive(null)} />
      <Footer />
    </div>
  );
};

export default MediaPage;
